export const SET_ALL_PRODUCTS = "SET_ALL_PRODUCTS";
export const SET_PRODUCT = "SET_PRODUCT";
